module.exports = __webpack_public_path__ + "img/Proliferation-BRCA_10X_Section2.5995dfae.png";